module.exports = __webpack_public_path__ + "static/media/excavation-10.f82740ae.jpg";